"use client";

import { useEoa } from "#/store/wallet/eoa/eoa";

export const useAccounts = () => {
  const { eoa } = useEoa();
  /// @dev Temporarily remove KyanSmartAccounts
  const accounts = eoa ? [eoa] : [];

  return { accounts };
};
